// Components

export { default as StickyHeading } from "./src/components/StickyHeading"